export enum FACET_SPECIALS {
  SEARCH = 'SEARCH',
  RANGE = 'RANGE'
}
